module.exports = __webpack_public_path__ + "img/Antonia&Stephan-19.533f28a4.jpg";